// components/MicosUploadCsvfileStepss.jsx
import React from 'react';
import Grid from '@mui/material/Grid2';
import { TypographyInstruction } from '../style/typography';
import UploadCsvfileSteps from './upload_csvfile_steps';

// 画像のimport
import micos_top from '../_img/micos_top.png';
import micos_setting from '../_img/micos_setting.png';
import micos_select from '../_img/micos_select.png';
import micos_csv_download from '../_img/micos_csv_download.png';

const ImageDisplay = ({ src, alt }) => (
  <img src={src} alt={alt} style={{ width: '100%', height: '100%' }} />
);

const MicosUploadCsvfileStepss = () => {
  return (
    <>
      {/* STEP1: 九州電力管内地震情報一覧を選択 */}
      <Grid size={12}>
        <UploadCsvfileSteps
          stepNumber="1"
          title="九州電力管内地震情報一覧を選択"
          description="MICOSにログインし、画面左側のメニューから「九州電力管内地震情報一覧」をクリックしてください。"
        >
          <ImageDisplay src={micos_top} alt="micos TOP画面" />
        </UploadCsvfileSteps>
      </Grid>

      {/* STEP2: 地震情報一覧のフィルタを設定 */}
      <Grid size={12}>
        <UploadCsvfileSteps
          stepNumber="2"
          title="地震情報一覧のフィルタを設定"
          description={
            <>
              画面右側の設定を、以下のように設定してください。<br />
              <ul style={{ marginTop: '8px', paddingLeft: '20px' }}>
                <li>
                  <TypographyInstruction>「エリア選択」を「大分」に変更</TypographyInstruction>
                </li>
                <li>
                  <TypographyInstruction>「設備選択」を「水力」に変更</TypographyInstruction>
                </li>
              </ul>
            </>
          }
        >
          <ImageDisplay src={micos_setting} alt="micos 設定" />
        </UploadCsvfileSteps>
      </Grid>

      {/* STEP3: 履歴選択から報告対象の震度情報を選択 */}
      <Grid size={12}>
        <UploadCsvfileSteps
          stepNumber="3"
          title="履歴選択から報告対象の震度情報を選択"
          description="履歴選択から、関係機関に報告を行う対象の震度情報を選択してください。"
        >
          <ImageDisplay src={micos_select} alt="micos 履歴選択" />
        </UploadCsvfileSteps>
      </Grid>

      {/* STEP4: CSVファイルをダウンロード */}
      <Grid size={12}>
        <UploadCsvfileSteps
          stepNumber="4"
          title="CSVファイルをダウンロード"
          description="選択した震度情報が表示されていることを確認し、間違いがなければ「ダウンロード」をクリックしてください。"
        >
          <ImageDisplay src={micos_csv_download} alt="micos csvダウンロード" />
        </UploadCsvfileSteps>
      </Grid>
    </>
  );
};

export default MicosUploadCsvfileStepss;